export default __webpack_public_path__ + "static/media/indicator-max.9cd1f313.png";